import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'commercial_carriergroup'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_a: new DATETIME()
    }
  }
}
